/* ============================================================================
   Dripurr Filter Replacements PDP behaviour.
   Header + premium cart drawer LIFTED from dripurr-pdp.js (reads window.DRIPURR_PDP).
   Below: gallery + per-package subscribe selector + sticky CTA + reveal/FAQ.
   ========================================================================== */
(() => {
  // ---------- Mobile announcement marquee — clone slides for seamless loop ----------
  if (window.matchMedia('(max-width: 767px)').matches){
    const annoInner = document.querySelector('.anno-inner');
    if (annoInner){
      Array.from(annoInner.children).forEach(s => {
        const clone = s.cloneNode(true);
        clone.setAttribute('aria-hidden','true');
        annoInner.appendChild(clone);
      });
    }
  }

  // ---------- Mobile hamburger menu ----------
  const hdrMenuBtn = document.getElementById('hdrMenu');
  const hdrDrawer  = document.getElementById('hdrDrawer');
  if (hdrMenuBtn && hdrDrawer){
    const closeDrawer = () => {
      hdrDrawer.classList.remove('open');
      hdrMenuBtn.setAttribute('aria-expanded', 'false');
      hdrDrawer.setAttribute('aria-hidden', 'true');
    };
    hdrMenuBtn.addEventListener('click', () => {
      const isOpen = hdrDrawer.classList.toggle('open');
      hdrMenuBtn.setAttribute('aria-expanded', String(isOpen));
      hdrDrawer.setAttribute('aria-hidden', String(!isOpen));
    });
    hdrDrawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));
  }

  // ---------- Header: search toggle + live cart count ----------
  (function(){
    const hdr = document.querySelector('.hdr');
    const searchBtn = document.getElementById('hdrSearch');
    const searchBar = document.getElementById('hdrSearchBar');
    if (hdr && searchBtn && searchBar){
      searchBtn.addEventListener('click', function(){
        const open = hdr.classList.toggle('hdr-search-open');
        searchBtn.setAttribute('aria-expanded', String(open));
        if (open){ const inp = searchBar.querySelector('input'); if (inp) inp.focus(); }
      });
    }
    const badge = document.getElementById('cartCount');
    if (badge){
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c && c.item_count > 0){ badge.textContent = c.item_count; badge.hidden = false; } })
        .catch(function(){});
    }
  })();

  // ---------- Premium cart drawer ----------
  (function(){
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cdOverlay');
    if (!drawer || !overlay) return;
    const cfg = window.DRIPURR_PDP || {};
    const itemsEl = document.getElementById('cdItems');
    const fmt = function(c){ return '$' + (c/100).toFixed(2); };
    const thumb = function(u, s){ return u ? u.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_'+s+'x$1$2') : ''; };
    let recs = null;
    // map filter variant -> its subscription selling plan + savings %
    const subPct = { "1m": 20, "6m": 30, "12m": 40 };
    const filterInfo = {};
    Object.keys(cfg.filters || {}).forEach(function(t){
      const f = cfg.filters[t];
      if (f && f.variantId && f.sellingPlanId) filterInfo[f.variantId] = { plan: f.sellingPlanId, pct: subPct[t] || 0 };
    });
    // marketing "was" anchor per variant (fountain $79->$59; filters vs one-time retail)
    const compareByVariant = {};
    if (cfg.fountain && cfg.fountain.variantId) compareByVariant[cfg.fountain.variantId] = 7900;
    const filterRetail = { "1m": 950, "6m": 5700, "12m": 11400 };
    Object.keys(cfg.filters || {}).forEach(function(t){
      const f = cfg.filters[t];
      if (f && f.variantId && filterRetail[t]) compareByVariant[f.variantId] = filterRetail[t];
    });

    function setBadge(n){
      const b = document.getElementById('cartCount');
      if (b){ if (n>0){ b.textContent = n; b.hidden = false; } else { b.hidden = true; } }
      const dc = document.getElementById('cdCount'); if (dc) dc.textContent = n;
    }
    function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()); }

    // "cart reserved" countdown (persists across the session)
    const RES_KEY='dripurrCartReserve', RES_MS=10*60*1000; let timerInt=null;
    function fmtClock(ms){ const t=Math.max(0,Math.floor(ms/1000)),m=Math.floor(t/60),s=t%60; return (m<10?'0':'')+m+':'+(s<10?'0':'')+s; }
    function reserveEnd(){ let e=parseInt(sessionStorage.getItem(RES_KEY),10); if(!e||e-Date.now()<=0){ e=Date.now()+RES_MS; try{sessionStorage.setItem(RES_KEY,String(e));}catch(x){} } return e; }
    function tickTimer(){ const el=document.getElementById('cdTimerClock'); if(el) el.textContent=fmtClock(reserveEnd()-Date.now()); }
    function startTimer(){ tickTimer(); if(timerInt) clearInterval(timerInt); timerInt=setInterval(tickTimer,1000); }
    function stopTimer(){ if(timerInt){ clearInterval(timerInt); timerInt=null; } }

    function open(){
      overlay.hidden = false;
      requestAnimationFrame(function(){ overlay.classList.add('show'); drawer.classList.add('open'); });
      drawer.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
      startTimer();
      render();
    }
    function close(){
      overlay.classList.remove('show'); drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow = '';
      stopTimer();
      setTimeout(function(){ if (!drawer.classList.contains('open')) overlay.hidden = true; }, 340);
    }

    function lineHTML(it){
      const cmp = compareByVariant[it.variant_id];
      const orig = Math.max(it.original_line_price, cmp ? cmp * it.quantity : 0);
      const disc = orig - it.final_line_price;
      const price = it.final_line_price === 0
        ? (disc>0 ? '<s>'+fmt(orig)+'</s> <span class="cd-free">FREE</span>' : '<span class="cd-free">FREE</span>')
        : (disc>0 ? '<s>'+fmt(orig)+'</s> <b>'+fmt(it.final_line_price)+'</b>' : '<b>'+fmt(it.final_line_price)+'</b>');
      const variantLine = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-item-variant">'+it.variant_title+'</div>' : '';
      const sub = it.selling_plan_allocation ? '<div class="cd-item-sub">Auto-refill &middot; renews until you cancel</div>' : '';
      const save = '';
      const fi = filterInfo[it.variant_id];
      let subOffer = '';
      if (fi && !it.selling_plan_allocation){
      } else if (fi && it.selling_plan_allocation){
        subOffer = '<button class="cd-unsub" data-key="'+it.key+'" data-vid="'+it.variant_id+'" data-plan="" data-qty="'+it.quantity+'" type="button">Switch to one-time purchase</button>';
      }
      const img = thumb(it.image, 128);
      return '<li class="cd-item">'
        + '<div class="cd-item-img">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</div>'
        + '<div class="cd-item-main"><div class="cd-item-top"><div class="cd-item-title">'+it.product_title+'</div>'
        + '<button class="cd-item-rm" data-key="'+it.key+'" type="button" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0-.6 12a2 2 0 0 1-2 1.9H8.6a2 2 0 0 1-2-1.9L6 7"/></svg></button></div>'
        + variantLine + sub + '<div class="cd-item-bot"><div class="cd-qty">'
        + '<button class="cd-q" data-key="'+it.key+'" data-d="-1" type="button" aria-label="Decrease">−</button><span>'+it.quantity+'</span>'
        + '<button class="cd-q" data-key="'+it.key+'" data-d="1" type="button" aria-label="Increase">+</button></div>'
        + '<div class="cd-item-price">'+price+'</div></div>' + save + subOffer + '</div></li>';
    }

    function render(){
      return getCart().then(function(cart){
        setBadge(cart.item_count);
        const empty = document.getElementById('cdEmpty');
        const foot = document.getElementById('cdFoot');
        const upsell = document.getElementById('cdUpsell');
        const timer = document.getElementById('cdTimer');
        const ship = document.querySelector('.cd-ship');
        const bannerDisp = cart.item_count === 0 ? 'none' : '';
        if (timer) timer.style.display = bannerDisp;
        if (ship) ship.style.display = bannerDisp;
        if (cart.item_count === 0){
          itemsEl.innerHTML=''; empty.hidden=false; foot.style.display='none'; if(upsell) upsell.hidden=true; return cart;
        }
        empty.hidden=true; foot.style.display='';
        const sorted = cart.items.slice().sort(function(a,b){ return (b.final_line_price - a.final_line_price) || (b.original_line_price - a.original_line_price); });
        itemsEl.innerHTML = sorted.map(lineHTML).join('');
        const totalDisc = cart.items.reduce(function(s,it){
          const c = compareByVariant[it.variant_id];
          const o = Math.max(it.original_line_price, c ? c*it.quantity : 0);
          return s + (o - it.final_line_price);
        }, 0);
        document.getElementById('cdSubtotal').innerHTML =
          (totalDisc>0 ? '<s>'+fmt(cart.total_price + totalDisc)+'</s> ' : '') + fmt(cart.total_price);
        document.getElementById('cdCheckoutTotal').textContent = ' · ' + fmt(cart.total_price);
        const saveEl = document.getElementById('cdSave');
        if (saveEl) saveEl.hidden = true;
        loadUpsell(cart);
        return cart;
      });
    }

    function change(key, qty){
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(r=>r.json()).then(function(){ render(); }).catch(function(){});
    }
    function addVariant(vid){
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})})
        .then(function(){ render(); }).catch(function(){});
    }

    function loadUpsell(cart){
      const wrap = document.getElementById('cdUpsell');
      const list = document.getElementById('cdUpsellList');
      if (!wrap || !list || !cfg.fountain || !cfg.fountain.productId) return;
      const paint = function(){
        const inCart = {}; cart.items.forEach(function(it){ inCart[it.product_id]=true; });
        const hidden = {15155052085616:1,15152531734896:1,14908225323376:1}; // bundle-gift & legacy SKUs — never upsell
        const show = (recs||[]).filter(function(p){ return p.available && !inCart[p.id] && !hidden[p.id]; }).slice(0,3);
        if (!show.length){ wrap.hidden=true; return; }
        wrap.hidden=false;
        list.innerHTML = show.map(function(p){
          const v = (p.variants&&p.variants[0])||{};
          const img = thumb(p.featured_image || (p.images&&p.images[0]) || '', 100);
          const vt = (v.title && v.title !== 'Default Title') ? '<span class="cd-up-var">'+v.title+'</span> · ' : '';
          return '<div class="cd-up-item"><div class="cd-up-img">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</div>'
            + '<div class="cd-up-info"><div class="cd-up-title">'+p.title+'</div><div class="cd-up-price">'+vt+fmt(v.price)+'</div></div>'
            + '<button class="cd-up-add" data-vid="'+v.id+'" type="button">Add</button></div>';
        }).join('');
      };
      if (recs){ paint(); return; }
      fetch('/recommendations/products.json?product_id='+cfg.fountain.productId+'&limit=10&intent=related',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok?r.json():{products:[]}; }).then(function(d){ recs = d.products||[]; paint(); }).catch(function(){ recs=[]; });
    }

    drawer.addEventListener('click', function(e){
      const b = e.target.closest('button'); if (!b) return;
      if (b.classList.contains('cd-q')){
        const span = b.parentNode.querySelector('span');
        const q = (parseInt(span.textContent,10)||1) + (b.getAttribute('data-d')==='1'?1:-1);
        change(b.getAttribute('data-key'), Math.max(0,q));
      } else if (b.classList.contains('cd-item-rm')){ change(b.getAttribute('data-key'),0); }
      else if (b.classList.contains('cd-sub-offer') || b.classList.contains('cd-unsub')){
        const key=b.getAttribute('data-key'), vid=b.getAttribute('data-vid'), plan=b.getAttribute('data-plan'), qty=Number(b.getAttribute('data-qty'))||1;
        b.disabled = true;
        const H={'Content-Type':'application/json','Accept':'application/json'};
        const addItem = plan ? {id:Number(vid),quantity:qty,selling_plan:Number(plan)} : {id:Number(vid),quantity:qty};
        fetch('/cart/change.js',{method:'POST',headers:H,body:JSON.stringify({id:key,quantity:0})})
          .then(function(){ return fetch('/cart/add.js',{method:'POST',headers:H,body:JSON.stringify({items:[addItem]})}); })
          .then(function(){ render(); }).catch(function(){ render(); });
      }
      else if (b.classList.contains('cd-up-add')){ addVariant(b.getAttribute('data-vid')); }
      else if (b.id==='cdClose' || b.id==='cdEmptyClose'){ close(); }
    });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && drawer.classList.contains('open')) close(); });

    const cartIcon = document.querySelector('.hdr-cart');
    if (cartIcon) cartIcon.addEventListener('click', function(e){ e.preventDefault(); open(); });

    window.DripurrCart = { open: open, close: close, render: render };
    getCart().then(function(c){ setBadge(c.item_count); }).catch(function(){});
  })();

  // ---------- Filter gallery (fountain-style: thumbs left, main image right) ----------
  (function(){
    const G = ((window.DRIPURR_PDP && window.DRIPURR_PDP.gallery) || []).map(function(g){ return g.src; }).filter(Boolean);
    const mainImg = document.getElementById('mainImg');
    const thumbsEl = document.getElementById('thumbs');
    if (!mainImg || !G.length) return;
    let idx = 0;
    function setImg(i){
      idx = (i + G.length) % G.length;
      mainImg.src = G[idx];
      document.querySelectorAll('.thumb').forEach(function(t,k){ t.classList.toggle('active', k === idx); });
    }
    if (thumbsEl){
      G.forEach(function(src,k){
        const b = document.createElement('button');
        b.className = 'thumb' + (k === 0 ? ' active' : '');
        b.type = 'button';
        b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
        b.addEventListener('click', function(){ setImg(k); });
        thumbsEl.appendChild(b);
      });
    }
    setImg(0);
    const prev = document.getElementById('prevImg'), next = document.getElementById('nextImg');
    if (prev) prev.addEventListener('click', function(){ setImg(idx - 1); });
    if (next) next.addEventListener('click', function(){ setImg(idx + 1); });
  })();

  // ---------- Per-package subscribe selector + sticky CTA ----------
  (function(){
    const cfg = window.DRIPURR_PDP || {};
    const F = cfg.filters || {};
    const subPct = { "1m": 20, "6m": 30, "12m": 40 };
    const meta = { "1m": {months:1, cad:"month"}, "6m": {months:6, cad:"6 months"}, "12m": {months:12, cad:"year"} };
    const labels = { "1m":"1-Month Supply", "6m":"6-Month Supply", "12m":"12-Month Supply" };
    if (!F["6m"] || !F["6m"].variantId) return;
    let dur = "6m";
    const modeOf = { "1m":"onetime", "6m":"onetime", "12m":"onetime" };
    const r2 = function(n){ return Math.round(n*100)/100; };
    const money = function(n){ n = r2(n); return '$' + (Number.isInteger(n) ? n : n.toFixed(2)); };
    const oneTime = function(t){ return ((F[t] && F[t].price) || 0) / 100; };
    const priceOf = function(t){ return modeOf[t] === 'sub' ? r2(oneTime(t) * (1 - subPct[t]/100)) : oneTime(t); };
    const setText = function(sel, txt){ const e = document.querySelector(sel); if (e) e.textContent = txt; };

    function render(){
      Object.keys(meta).forEach(function(t){
        const card = document.querySelector('.fp-tier[data-dur="'+t+'"]');
        if (!card || !F[t]) return;
        const isSub = modeOf[t] === 'sub', cur = priceOf(t), one = oneTime(t);
        const curEl = card.querySelector('.fp-tier-cur'); if (curEl) curEl.textContent = money(cur);
        const origEl = card.querySelector('.fp-tier-orig'); if (origEl){ if (isSub){ origEl.textContent = money(one); origEl.hidden = false; } else origEl.hidden = true; }
        const perEl = card.querySelector('.fp-tier-per'); if (perEl) perEl.textContent = money(cur / meta[t].months) + '/mo';
        const saveEl = card.querySelector('.fp-tier-save'); if (saveEl){ if (isSub){ saveEl.textContent = 'Save ' + subPct[t] + '%'; saveEl.hidden = false; } else saveEl.hidden = true; }
        card.querySelectorAll('.fp-mode').forEach(function(m){ m.classList.toggle('active', m.getAttribute('data-mode') === modeOf[t]); });
        card.classList.toggle('active', t === dur);
      });
      const isSub = modeOf[dur] === 'sub', lbl = isSub ? 'Subscribe' : 'Add to Cart', pr = money(priceOf(dur));
      setText('#fpCta .fp-cta-label', lbl); setText('#fpCta .fp-cta-price', pr);
      const note = document.getElementById('fpSubNote');
      if (note) note.textContent = isSub ? ('Auto-renews every ' + meta[dur].cad + ' until you cancel · skip or stop online anytime.') : 'One-time purchase · free shipping included.';
      setText('#fpStickyName', labels[dur] + (isSub ? ' · Subscribe' : ''));
      setText('#fpStickyCta .fp-cta-label', lbl); setText('#fpStickyCta .fp-cta-price', pr);
    }

    document.querySelectorAll('.fp-tier').forEach(function(el){
      el.addEventListener('click', function(e){ if (e.target.closest('.fp-mode')) return; dur = el.getAttribute('data-dur'); render(); });
    });
    document.querySelectorAll('.fp-mode').forEach(function(el){
      el.addEventListener('click', function(e){ e.stopPropagation(); const card = el.closest('.fp-tier'); const t = card.getAttribute('data-dur'); modeOf[t] = el.getAttribute('data-mode'); dur = t; render(); });
    });

    function addToCart(btn){
      const f = F[dur]; if (!f || !f.variantId) return;
      const item = { id: Number(f.variantId), quantity: 1 };
      if (modeOf[dur] === 'sub' && f.sellingPlanId) item.selling_plan = Number(f.sellingPlanId);
      btn.disabled = true;
      fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items:[item] }) })
        .then(function(){ btn.disabled = false; if (window.DripurrCart) window.DripurrCart.open(); else window.location.href = '/cart'; })
        .catch(function(){ btn.disabled = false; });
    }
    const cta = document.getElementById('fpCta'); if (cta) cta.addEventListener('click', function(){ addToCart(cta); });
    const scta = document.getElementById('fpStickyCta'); if (scta) scta.addEventListener('click', function(){ addToCart(scta); });

    // Sticky bar: show once the main CTA scrolls out of view, hide over the final CTA
    const sticky = document.getElementById('fpSticky');
    if (sticky && cta && 'IntersectionObserver' in window){
      let ctaOut = false, finalIn = false;
      const upd = function(){ sticky.classList.toggle('show', ctaOut && !finalIn); };
      new IntersectionObserver(function(es){ ctaOut = !es[0].isIntersecting; upd(); }, { rootMargin: '-70px 0px 0px 0px' }).observe(cta);
      const finalEl = document.getElementById('fpFinal');
      if (finalEl) new IntersectionObserver(function(es){ finalIn = es[0].isIntersecting; upd(); }).observe(finalEl);
    }
    render();
  })();

  // ---------- Scroll reveal + FAQ accordion ----------
  (function(){
    const els = document.querySelectorAll('.reveal');
    if (els.length && ('IntersectionObserver' in window)){
      const io = new IntersectionObserver(function(en){ en.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function(e){ io.observe(e); });
    } else { els.forEach(function(e){ e.classList.add('in'); }); }
    document.querySelectorAll('.hm-faq-q').forEach(function(btn){
      btn.addEventListener('click', function(){ const item = btn.closest('.hm-faq-item'); const open = item.classList.toggle('open'); btn.setAttribute('aria-expanded', String(open)); });
    });
  })();

})();
